"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function tableWidthStyle(style, attributes) {
    var type = attributes['w:type'];
    style += "table-layout:" + (type === 'fixed' ? 'fixed' : 'auto') + ";";
    return style;
}
exports.default = tableWidthStyle;



//////////////////
// WEBPACK FOOTER
// ./node_modules/file2html-ooxml/lib/word/styles/table-layout.js
// module id = 1791
// module chunks = 0